(function () { if (!LN.Core || !LN.Model) throw new Error("LN.Core || LN.Model missing"); })();

(function (Model, Config, Helper, Validation) {
  'use strict';

    Model.Campania = {}
    Model.Landing = {}
    Model.PlanElegido = {}
    Model.PlanMonto = {};

    Model.canalDeVenta = 0;
    Model.productCategory = "";
    Model.idOrigen = 0;

    Model.Newsletter = [];

    Model.pin = '';
    Model.pinUrl = '';
    Model.pinDesc = '';

  Model.ComboAccesoSuscripcion = false;
  Model.YaTieneSuscripcion = false;

  Model.Cliente = {
    apellido: "",
    email: "",
    nombre: "",
    numeroDocumento: "",
    telefonoCelular: "",
    telefonoInterno: "",
    tipoDocumento: "",
    planElegido: null,
    mailOfuscado: ""
  }

    Model.Domicilios = []
    Model.DomicilioElegido = {}
    Model.DomicilioTemp = {}
    Model.SWGSubscriptions = null
   
    Model.Usuario = {
        UsuarioId: "",
        AccessToken: "",
        OrigenLoginTipoId: "",
        TipoAsociarCredencial: "",
        xToken: "",
        xValue: "",
        Retorno: "",
        UsuarioUsuario: "",
        Email: "",
        EmailCodificado: "",
        UsuarioDetalleNombre: "",
        UsuarioDetalleApellido: "",
        Credencial: "",
        Credenciales: [],
        tipoDocumento: "",
        dni: "",
        tipoParticipacion: "",
        UserAgent: "",
        Recaptcha: "",
        Codigo: "",
        SitioId: 1,
        EstadoId: "",
        Avatar: Config.urlAvatar + 'avatar-0.jpg',
        Campania: null,
        Combo: 0,
        ComboNombre: "",
        ComboPrecio: "",
        ComboPrecioSinDescuento: "",
        esProvisorio: false
    }

  Model.Window = {
    width: "",
    height: "",
    body: "",
    html: "",
    origenId: "",
    sitioId: "",
    modo: "",
    combo: "",
    pagina: "",
    paginaId: "",
    path: "",
    referer: "",
    userAgent: "",
    origenLoginTipoId: "",
    currentStep: "",
    currentLayout: "",
    lastFlow: "",
    canSubmit: true,
    ip: "",
    keyPress: 0,
    firstStart: true,
    location: window.location.href,
    origin: window.location.origin,
    errorAttemps: 0,
    contact: 0,
    originForCallback: "",
    source: "",
    isSafari : false 
  }

    Model.Embed = {
        Mobile: false,
        Article: false,
        Name:""
    }

    Model.ExternalPaywall = { 
        Name: "",
        Type: "",
        Params: [],
        AutorizationToken : ""
    }

   

    Model.FormularioDatosPersonales = {};
    Model.FormularioDatosEnvio = {};
    Model.Me = {};

    Model.Venta = {
        Domicilio: null,
        esExtranjero: false,
        Pago: null,
        Background : false,
    };
   // ==================================================
    // METODOS PRIVADOS
    // ==================================================       

    const UpdateExternalPaywall = function () {
        for (const item in Config.ExternalPaywall) {
            let this_paywall_is_active = false;
            let values = [];
            for (const param in Config.ExternalPaywall[item].Params) {
                if (Helper.isEmpty(Helper.getURLParameter1(Config.ExternalPaywall[item].Params[param])))
                {
                    this_paywall_is_active = false;
                }
                else {
                    /*let obj = {};
                    obj[Config.ExternalPaywall[item].Params[param]] = Helper.getURLParameter1(Config.ExternalPaywall[item].Params[param]);*/
                    values[Config.ExternalPaywall[item].Params[param]] = Helper.getURLParameter1(Config.ExternalPaywall[item].Params[param]);
                    this_paywall_is_active = true;
                }
            }
            if (this_paywall_is_active) {
                //si sali del for por true , este paywall esta configurado
                Model.Embed[Config.ExternalPaywall[item].Type] = true;
                Model.Embed.Name = Config.ExternalPaywall[item].Name;
                Model.ExternalPaywall = Config.ExternalPaywall[item];
                Model.ExternalPaywall.Values = values;
                break; 
            }
        }
    };


    // ==================================================
    // Inicializacion de las variables de entorno
    // ==================================================       

    Model.updateAccesoWindowModel = function () {
        Model.Window.modo = ((Helper.getURLPathParameter('param1') !== null && Helper.modoPermitido(Helper.getURLPathParameter('param1'))) ? Helper.getURLPathParameter('param1') : null);
        Model.Window.SitioId = ((Helper.getURLPathParameter('param3') !== null && Helper.sitioPermitido(parseInt(Helper.getURLPathParameter('param3')))) ? parseInt(Helper.getURLPathParameter('param3')) : Config.defaultSitioId);
        Model.Window.combo = ((Helper.getURLPathParameter('param2') !== null) ? parseInt(Helper.getURLPathParameter('param2')) : null);

        Model.Window.landingUrl = ((Helper.getURLPathParameter('param1') !== null) ? (Helper.getURLPathParameter('param1')) : null);
        if (Helper.getURLParameter1('campaign') != null) {
            Model.Window.landingCampaign = Helper.getURLParameter1('campaign');
        }

        Model.Embed.Mobile = (LN.Helper.readCookie("platform") !== '' && LN.Helper.readCookie("platform") != null) ? LN.Helper.readCookie("platform") : false;

        if (Model.Embed.Mobile) {
            Model.Embed.Name = (LN.Helper.readCookie("platformName") !== '' && LN.Helper.readCookie("platformName") != null) ? LN.Helper.readCookie("platformName") : "App Android";
        }

        UpdateExternalPaywall();
        // Pagina
        var base64Matcher = new RegExp("^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$");
        if (Helper.getURLParameter1('callback') != null) {
            if (base64Matcher.test(LN.Helper.getURLParameter1('callback'))) {
                Model.Window.pagina = ((Config.dominiosPermitidos.test(window.atob(Helper.getURLParameter1('callback')))) ? window.atob(Helper.getURLParameter1('callback')) : Config.defaultRedirectUrl);
            } else {
                Model.Window.pagina = Config.defaultRedirectUrl
            }
        } else {
            if (base64Matcher.test(LN.Helper.getURLQueryString())) {
                Model.Window.pagina = ((Config.dominiosPermitidos.test(window.atob(Helper.getURLQueryString()))) ? window.atob(Helper.getURLQueryString()) : Config.defaultRedirectUrl)
            } else {
                Model.Window.pagina = Config.defaultRedirectUrl
            }
        }

        if (Helper.getURLParameter1('fc') != null) {
            Model.Window.contact = parseInt(Helper.getURLParameter1('fc'));
        }

        if (Helper.getURLParameter1('productCategory') != null) {
            Model.productCategory = Helper.getURLParameter1('productCategory');
        }
        var is_safari = navigator.userAgent.indexOf("Safari") > -1;
        // Chrome has Safari in the user agent so we need to filter (https://stackoverflow.com/a/7768006/1502448)
        var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
        if ((is_chrome) && (is_safari)) {
            is_safari = false;
        }
        if (is_safari) {
            Model.Window.isSafari = true;
        }
        
        if (Helper.getURLParameter1('ref') != null) {
            Model.refWall = window.atob(Helper.getURLParameter1('ref'));
        }
        else {
            Model.refWall = "";
        }
          

        // Fin pagina
        let numberPattern = /\d+/g;

        if (Model.Window.pagina.split('-nid')[1] && Model.Window.pagina.split('-nid')[1].match(numberPattern) && Model.Window.pagina.split('-nid')[1].match(numberPattern)[0]) {
            Model.Window.paginaId = Model.Window.pagina.split('-nid')[1].match(numberPattern)[0];
        }
        Model.Window.path = Helper.getURLPath();
        Model.Usuario.SitioId = Model.Window.SitioId;

        Model.Variant = Helper.getPaywallVariant();

    }

    Model.IsInstantArticles = function () {
        if (Model.Embed.Article === true && Model.Embed.Name === "FacebookInstantArticles") {
            return true;
        }
        return false
    }

    Model.setUsuario = function () {
      Model.Usuario.UsuarioUsuario = ((LN.Helper.readCookie("token") && Helper.readCookie("token") !== '' && Helper.readCookie("usuario%5Fusuario") && Helper.readCookie("usuario%5Fusuario") !== '') ? Helper.readCookie("usuario%5Fusuario") : null);
      Model.Usuario.Email = ((LN.Helper.readCookie("token") && Helper.readCookie("token") !== '' && Helper.readCookie("usuarioemail") && Helper.readCookie("usuarioemail") !== '') ? Helper.readCookie("usuarioemail") : null);
    }

  Model.getAllInputs = function () {
    var inputs = $(':input');
    var values = {};
    inputs.each(function () {
      values[this.name] = $(this).val();
    });
    return values;
  }

  Model.getInputsBy = function (step, name, error) {
    var inputs = $(':input[name^="' + step + '"]');
    var values = [];
    this.output = [];
    inputs.each(function () {
      var n = $(this).attr("name").match(/\[.*?\]/);
      var o = n[0].replace("[", "").replace("]", "");
      var c = $(this).attr('class')
      if (c) c.split(/\s+/);
      values[o] = {
        'name': o,
        'value': $(this).val(),
        'validations': c,
        'object': $(this),
        'text': ($(this).is('select') ? $(this).children("option:selected").text() : $(this).val())
      }
    });

    function get() {
      if (!Helper.isEmpty(name) && values.indexOf(name) === -1) {
        if (Helper.isEmpty(values[name]) && Helper.isEmpty(values[name].object) && values[name].object.is(':radio') && !values[name].object.is(':checked')) {
          return false;
        } else if (Helper.isEmpty(values[name]) && values[name].object.is(':radio') && values[name].object.is(':checked')) {
          return values[name]
        }
        return values[name]
      }
    }

    function set(value) {
      if (!Helper.isEmpty(name) && values.indexOf(name) === -1) {
        return values[name].object.val(value);
      }
    }

    function all() {
      return values;
    }

    function clean() {
      for (var key in values) {
        var o = values[key].object;
        if (o.attr('type') == 'text' || o.attr('type') == 'number') {
          o.val('');
          Helper.cleanStatus(o);
        }
      }
    }

    function save(obj) {
      for (var key in values) {
        var k = values[key].name;
        var v = values[key].value;
        obj[k] = v;
      }
    }

    function validate() {
      if (Helper.isEmpty(name) && values.indexOf(name) !== -1) return false;
      var v = values[name];
      return Validation.checkValidations(v.object);
    }

    return ({
      get: get,
      set: set,
      all: all,
      save: save,
      clean: clean,
      validate: validate,
    });
  }

  Model.updateModel = function (step) {
    var data = Model.getInputsBy('datos_personales');
    for (var key in data) {
      Model.DatosPersonales[key] = data[key].value
    }
  }

  Model.updatePinFromUrl = function () {
    Model.pin = Helper.getURLParameter('param1');
  }

  Model.getAction = function () {
    return Helper.getURLParameter1('a');
  }

  Model.updateDatosEnvio = function () {
    var data = Model.getInputsBy('datos_personales');
  }

  Model.setMe = function (res) {
    Model.Me = JSON.parse(res.response);
    if (!Helper.isEmpty(Model.Me.Usuario.Usuario_detalle_foto_perfil)) {
      Model.Usuario.Avatar = Config.urlAvatar + 'avatar-' + Model.Me.Usuario.Usuario_detalle_foto_perfil + '.jpg'
    }
  }

  Model.setCliente = function (res) {
    Model.Cliente = $.extend(Model.Cliente, res.response);
  }

  Model.setPago = function (pago) {
    Model.Venta.Pago = pago;
  }

  //Model.setPreventa = function (res) {
  //    Model.Preventa = res.response;
  //}

    
    Model.setPlanMonto = function (monto) {
        Model.PlanMonto = monto;
    }

    Model.setCombo = function (combo) {
       
        if (combo == Config.COMBO_BONIFICADO) {
            Model.PlanElegido = {};
            Model.PlanElegido.nombre = "Acceso Digital Bonificado";
            Model.Cliente.numeroDocumento = "";
            Model.Cliente.tipoDocumento = "";
        }
        else
        {
            let plan = Model.getPlan(combo);
            Model.Usuario.Credenciales = [];
            Model.PlanElegido = plan.planes[0];
            let wall = Model.wallConfig.walls[0];
            let comboFound = wall.comboCards.find(comboCard => comboCard.comboId == combo)
            if (comboFound) {
                let features = comboFound.features;
                Model.PlanElegido.features = features;
            }
           
            if (plan.imagenProducto) {
                Model.PlanElegido.imagen = plan.imagenProducto;
            }
            else {
                Model.PlanElegido.imagen = Config.urlBucket + plan.imagen.url; 
            } 
            Model.PlanElegido.imagenExtranjera = plan.imagenExtranjera;
        }
    }
  
    
    Model.updateCanalDeVenta = function (modo) {
        // Si el Canal de Venta no se encuentra en la URL, lo levanto del archivo de configuraci�n.
        if (Helper.getURLParameter1('cv') != null) {
            Model.canalDeVenta = parseInt(Helper.getURLParameter1('cv'));
        } else { 
            if (!modo) modo = 'W';
            let idCanal = (Config.canalesDeVenta[modo] === undefined) ? Config.canalesDeVenta["W"] : Config.canalesDeVenta[modo];

      Model.canalDeVenta = idCanal;
    }
  }

  Model.setDomicilios = function (res) {
    Model.Domicilios = [];
    if (res.response.domicilios && Config.forceCreateNewAddress == false) {
      for (var i in res.response.domicilios) {
        var a = res.response.domicilios[i];
        if (!Helper.isEmpty(a.domicilio)) {
          Model.Domicilios.push(a);
        }
      }
      //Model.Domicilios = res.response.domicilios;
    } else {
      Model.Domicilios = [];
    }
  }

  Model.getFirstDomicilio = function () {
    if (!Helper.isEmpty(Model.Domicilios[0])) return Model.Domicilios[0];
    return false;
  }

  Model.obtenerDirecciones = function () {
    return Model.Domicilios;
  }

  Model.agregarDireccion = function (a) {
    return Model.Domicilios.push(a);
  }

  Model.getPlan = function (combo) {
    let plan = null;
    $.each(Model.Campania.grupoPlanes, function (i, e) {
      if (e.combo == combo) {
        plan = e;
        return;
      }
    });
    return plan;
  }

  Model.getPlanById = function (id) {
    let plan = null;
    $.each(Model.Campania.grupoPlanes, function (i, e) {
      if (e.id == id) {
        plan = e;
        return;
      }
    });
    return plan;
  }

    Model.FormatearProductosBajadaLanding = function () {
        this.BajadaPlanSeparada = [];
        for (var i in Model.Landing.PlanesDeVenta) {
            try {
                Model.Landing.PlanesDeVenta[i].BajadaPlanSeparada = Model.Landing.PlanesDeVenta[i].BajadaPlan.split('+').map(x => x.trim()).sort();
            } catch (ex) {
                console.log("Error formateando productos bajada landing");
            }
        }
    }

    Model.LoadNewsLetter = function (servicios) {
        let ids= servicios.map(x => x.servicio_id);
        if (ids.length > 0)
            Model.Newsletter = Model.Newsletter.concat(ids);
    }

    Model.LoadNewsLetter = function (servicios) {
        let ids = servicios.map(x => x.servicio_id);
        if (ids.length > 0)
            Model.Newsletter = Model.Newsletter.concat(ids);
    }

    Model.IsCheckedNewsletter = function (id) {
        return Model.Newsletter.find(x => x == id);
    }

    Model.InitializeNewsletter = function (combo) {
        Model.Newsletter = [];

        if (combo != Config.COMBO_BONIFICADO && Model.PlanElegido.planConCredencial) {
            Model.Newsletter.push(Config.Newsletter.Club);
        }
        Model.Newsletter.push(Config.Newsletter.LoQueHayQueSaber);
    }

    Model.InitializeNewsletterBonificado = function () {
        Model.Newsletter = [];
        Model.Newsletter.push(Config.Newsletter.LoQueHayQueSaber);
    }
        

})(LN.Model, LN.Config, LN.Helper, LN.Validation);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/model.js